export class TrimCodereqts{
    trimCode:string
    sampleRequestId?:number
    constructor(trimCode:string,sampleRequestId?:number){
this.trimCode=trimCode
this.sampleRequestId=sampleRequestId
    }
}